(function($) {

  var site = window.site || {};
  site.foundationFinder = site.foundationFinder || {};

  function _initQuiz(context, settings) {
    var $quiz = $('.ff-quiz', context);
    var $slides = $('.ff-quiz__slide', $quiz);
    var $questions = $('.ff-quiz__question', $quiz);
    var $answers = $('.ff-quiz__answer', $quiz);
    var $nextBtn = $('.ff-quiz__button--next', $quiz);
    var $filterBtn = $('.ff-quiz__filter-button', $quiz);
    var $navItems = $('.ff-quiz__nav-item', $quiz);
    var $slider = $('.js-ff-quiz__slider--coverage', $quiz);
    var $slider2 = $('.js-ff-quiz__slider--intensity', $quiz);
    var $closeBtn = $('.ff-quiz__edit-close', $quiz);

    var itemCount = $navItems.length;
    var slideIndex = 1;


    // Do something when a question is answered
    $answers.on('click', function(e) {
      e.preventDefault();
      var answer = $(this).data('answer');
      var translated_answer = ($(this).data('translated_answer')) ? $(this).data('translated_answer').replace(/(<([^>]+)>)/ig,"") : "";
      var $slide = $(this).parents('.ff-quiz__slide');

      $('.ff-quiz__answer', $slide).removeClass('active');
      $(this).addClass('active');
      $slide.addClass('selected');

      // if first question (coverage) do this also
      if ($slide.index() === 0) {
        if (answer == 'sheer') {
          $slider.val(20);
        } else if (answer == 'medium') {
          $slider.val(50);
        } else if (answer == 'full') {
          $slider.val(80);
        }
      }

      // if fourth question (intensity) do this also
      if ($slide.index() === 3) {
        var answers_length = $slide.find('ul').find('li').length + 1;
        var answer_key = $(this).data('answer-key');
        var slider_val = 100/answers_length*answer_key;
        $slider2.val(slider_val);
      }

      var update_nav_text = translated_answer || answer;
      $navItems.eq($slide.index()).addClass('selected').find('.ff-quiz__nav-value').text(update_nav_text);
      $slide.find($nextBtn).toggleClass('ff-quiz__button--results', (slideIndex == itemCount)).addClass('active');
    });

    // Navigation breadcrumbs
    $navItems.click(function(e) {
      e.preventDefault();
      var $slide = $(this).parents('.ff-quiz__slide');
      var index = $(this).parent().index();
      if ($(this).hasClass('selected')) {
        $slides.removeClass('active');
        $slide.addClass('active');
        $slides.not('.active').find('.ff-quiz__slide--content').slideUp();
        $slides.eq(index).find('.ff-quiz__slide--content').slideDown();
      }
    });

    /*
      Question 1 interactions (Coverage)
    */
    // Init slider ui
    $slider.noUiSlider({
      start: [0],
      step: 10,
      range: {
        'min': [ 0 ],
        'max': [ 100 ]
      }
    }).on({
      slide: function(){
        var val = $slider.val();
        var $img = $('.ff-quiz__coverage-image');
        var $imgSheer = $('.ff-quiz__coverage-image--sheer');
        var $imgMedium = $('.ff-quiz__coverage-image--medium');
        var $imgFull = $('.ff-quiz__coverage-image--full');
        var $imgSlide = $('.ff-quiz__coverage-image--slide');
        if (val < 50 && val >= 10) {
          // Sheer
          $img.not($imgSheer).hide();
          if (!$imgSheer.is(':animated')) {
            $img.stop().css('opacity', 1);
            $imgSheer.fadeIn();
          }
        } else if (val < 80 && val >= 50) {
          // Medium
          $img.not($imgMedium).hide();
          if (!$imgMedium.is(':animated')) {
            $img.stop().css('opacity', 1);
            $imgMedium.fadeIn();
          }
        } else if (val <= 100 && val > 50) {
          // Full
          $img.not($imgFull).hide();
          if (!$imgFull.is(':animated')) {
            $img.stop().css('opacity', 1);
            $imgFull.fadeIn();
          }
        } else if (val === 0) {
          $img.hide();
          if (!$imgSlide.is(':animated')) {
            $img.stop().css('opacity', 1);
            $imgSlide.fadeIn();
          }
        }
      },
      change: function(){
        var val = $slider.val();
        var $slide = $(this).parents('.ff-quiz__slide');
        if (val < 50 && val >= 0) {
          // Sheer
          $('.ff-quiz__answer--sheer', $slide).click();
        } else if (val < 80 && val >= 50) {
          // Medium
          $('.ff-quiz__answer--medium', $slide).click();
        } else if (val <= 100 && val > 50) {
          // Full
          $('.ff-quiz__answer--full', $slide).click();
        }
      }
    });

    // Image swap
    $('.ff-quiz__button--coverage').click(function(e) {
      e.preventDefault();
      var answer = $(this).data('answer');
      if ($.inArray(answer, ['sheer', 'medium', 'full']) > -1) {
        $('.ff-quiz__coverage-image').hide();
        $('.ff-quiz__coverage-image--' + answer).show();
      }
    });

    /*
      Question 4 Interactions (Intensity)
    */
    // Init slider ui
    var answers_length = $('.ff-quiz__slide--4 .ff-quiz__question').find('li').length + 1;
    var step_width = 100/$('.ff-quiz__slide--4 .ff-quiz__question').find('li').length;
    $('.ff-quiz__slide--4 .ff-quiz__question').find('li').css('width', step_width+'%');
    var step_val = 100/answers_length;
    step_val = Math.round(step_val*100)/100;

    $slider2.noUiSlider({
      start: [0],
      step: step_val,
      range: {
        'min': [ 0 ],
        'max': [ 100 ]
      }
    }).on({
      slide: function(){
        var val = $slider2.val();
        var $img = $('.ff-quiz__intensity-image');
        var $imgIntensity01 = $('.ff-quiz__intensity-image--01');
        var $imgIntensity02 = $('.ff-quiz__intensity-image--02');
        var $imgIntensity03 = $('.ff-quiz__intensity-image--03');
        var $imgIntensity04 = $('.ff-quiz__intensity-image--04');
        var $imgIntensity05 = $('.ff-quiz__intensity-image--05');
        var $imgIntensity06 = $('.ff-quiz__intensity-image--06');
        var $imgIntensity07 = $('.ff-quiz__intensity-image--07');
		var $imgIntensity08 = $('.ff-quiz__intensity-image--08');
        var $imgSlide = $('.ff-quiz__intensity-image--slide');
        if (val == step_val*1) {
          // Very Light
          $img.not($imgIntensity01).hide();
          if (!$imgIntensity01.is(':animated')) {
            $img.stop().css('opacity', 1);
            $imgIntensity01.fadeIn();
          }
        } else if (val == step_val*2) {
          // Light
          $img.not($imgIntensity02).hide();
          if (!$imgIntensity02.is(':animated')) {
            $img.stop().css('opacity', 1);
            $imgIntensity02.fadeIn();
          }
        } else if (val == step_val*3) {
          // Light-Medium
          $img.not($imgIntensity03).hide();
          if (!$imgIntensity03.is(':animated')) {
            $img.stop().css('opacity', 1);
            $imgIntensity03.fadeIn();
          }
        } else if (val == step_val*4) {
          // Medium
          $img.not($imgIntensity04).hide();
          if (!$imgIntensity04.is(':animated')) {
            $img.stop().css('opacity', 1);
            $imgIntensity04.fadeIn();
          }
        } else if (val == step_val*5) {
          // Medium-Deep
          $img.not($imgIntensity05).hide();
          if (!$imgIntensity05.is(':animated')) {
            $img.stop().css('opacity', 1);
            $imgIntensity05.fadeIn();
          }
        } else if (val == step_val*6) {
          // Deep
          $img.not($imgIntensity06).hide();
          if (!$imgIntensity06.is(':animated')) {
            $img.stop().css('opacity', 1);
            $imgIntensity06.fadeIn();
          }
        } else if (val == step_val*7) {
          // Very Deep
          $img.not($imgIntensity07).hide();
          if (!$imgIntensity07.is(':animated')) {
            $img.stop().css('opacity', 1);
            $imgIntensity07.fadeIn();
          }
        } else if (val == step_val*8) {
          // Very Deep
          $img.not($imgIntensity08).hide();
          if (!$imgIntensity08.is(':animated')) {
            $img.stop().css('opacity', 1);
            $imgIntensity08.fadeIn();
          }
        } else if (val === 0) {
          $img.not($imgSlide).hide();
          if (!$imgSlide.is(':animated')) {
            $img.stop().css('opacity', 1);
            $imgSlide.fadeIn();
          }
        }
      },
      change: function(){
        var val = Number($slider2.val());
        var $slide = $(this).parents('.ff-quiz__slide');
        if (val <= (step_val*1).toFixed(2) && val >= 0) {
          $('.ff-quiz__answer--01', $slide).click();
        } else if (val == (step_val*2).toFixed(2) ) {
          $('.ff-quiz__answer--02', $slide).click();
        } else if (val == (step_val*3).toFixed(2) ) {
          $('.ff-quiz__answer--03', $slide).click();
        } else if (val == (step_val*4).toFixed(2) ) {
          $('.ff-quiz__answer--04', $slide).click();
        } else if (val == (step_val*5).toFixed(2) ) {
          $('.ff-quiz__answer--05', $slide).click();
        } else if (val == (step_val*6).toFixed(2) ) {
          $('.ff-quiz__answer--06', $slide).click();
        } else if (val == (step_val*7).toFixed(2) ) {
          $('.ff-quiz__answer--07', $slide).click();
        } else if (val <= 100 && val >= (step_val*8).toFixed(2) ) {
          $('.ff-quiz__answer--08').click();
        } else {
          $slide.find('ul').find('li').last().find('a').click();
        }
      }
    });

    // Image swap
    $('.ff-quiz__button--intensity').click(function(e) {
      e.preventDefault();
      var answer = $(this).data('answer');
      if ($.inArray(answer, ['01', '02', '03', '04', '05', '06', '07', '08']) > -1) {
        $('.ff-quiz__intensity-image').hide();
        $('.ff-quiz__intensity-image--' + answer).show();
      }
    });

    // Go to next slide
    $nextBtn.click(function(e) {
      e.preventDefault();
      var $slide = $(this).parents('.ff-quiz__slide');
      // Go to the next slide if we're not already on the last slide:
      if ($slide.index()+1 != itemCount) {
        $slide.removeClass('active').find('.ff-quiz__slide--content').slideUp();
        $slide.next().addClass('active').find('.ff-quiz__slide--content').slideDown();
      } else {
        // Otherwise, save answers and show results:
        $filterBtn.trigger('click');
      }
    });

    $closeBtn.on('click', function(event) {
      event.preventDefault();
      $quiz.addClass('collapsed');
      $navItems.removeClass('active');
    });

    $filterBtn.on('click', function(event) {
      event.preventDefault();

      var answers = {};
      $questions.each(function() {
        var $answer = $('.ff-quiz__answer.active', this);
        var answerKey = $answer.data('answer-key') || $answer.data('answer');
        answers[$(this).data('question-key')] = answerKey;
      });

      site.foundationFinder.initResults(document, answers);
    });

    
    $('.ff-quiz__start-over-link', $quiz).on('click', function(event) {
      event.preventDefault();
          site.foundationFinder.initResults(document);
          // Reset the quiz on the front end:
          $quiz.removeClass('ff-quiz--edit');
          $(window).trigger('resize');
          $answers.removeClass('active');
          $navItems.removeClass('selected');
          $nextBtn.removeClass('active');
          $('.ff-quiz__nav-value').text('');
          $carousel.slick('slickSetOption', 'speed', 0).slick('slickGoTo', 0).slick('slickSetOption', 'speed', 950);
          $slider.val(0);
          $slider2.val(0);
          $('.ff-quiz__coverage-image, .ff-quiz__intensity-image', $quiz).hide();
          $('.ff-quiz__coverage-image--slide, .ff-quiz__intensity-image--slide', $quiz).show().css({'opacity':'0.2'});
    });

    $('body').addClass('foundation-finder-page');
  }

  Drupal.behaviors.ffQuiz = { attach: _initQuiz };

})(jQuery);
